/**
 * Load GTM script tag
 * @param {String}  id  GTM ID
 */
export const loadScript = id => {
  if (isGTMReady() === false || !id) {
    return
  }

  const dl = 'dataLayer'
  const script = document.createElement('script')

  window[dl] = window[dl] || []

  window[dl].push({
    event: 'gtm.js',
    'gtm.start': new Date().getTime(),
  })

  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`

  document.body.appendChild(script)
}

export const launchGAPageView = pagePath => {
  if (isGTMReady() === false || isGAReady() === false) {
    return
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'GTR-WATCH_Pageview',
    pagePath,
  })
}

export const launchGAEvent = (eventCategory, eventAction, eventLabel) => {
  if (isGTMReady() === false || isGAReady() === false) {
    return
  }
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'GTR-WATCH_Event',
    eventCategory,
    eventAction,
    eventLabel,
  })
}

function isGTMReady() {
  if (process.server || !window) {
    return false
  }
  return true
}

function isGAReady() {
  try {
    const lpeConsent = window.localStorage.getItem('lpe-consent')
    if (lpeConsent !== null) {
      return JSON.parse(lpeConsent).ga
    }
    return true
  } catch (err) {
    return false
  }
}

export const initGtrUA = key => {
  window.uaGtrKey = key
}
